
import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import Select from "../../form/Select";
import DateTimeInput from "../../form/DateTimeInput";

class DeliveryForm extends React.Component {

    render() {
        const senderValue = this.props.values.sender || {id: null, name: this.props.values.sender_name};
        const recipientValue = this.props.values.recipient || {id: null, name: this.props.values.recipient_name};
        return (
            <form onSubmit={this.props.handleSubmit}>
                {this.props.componentEditor === "MainMenuDelivery" ?
                    <>
                        <div className="row form-row">
                            <div className="col-md-6">
                                <Select
                                    label="Kitől / honnan"
                                    name="sender"
                                    component="user"
                                    objectValue={true}
                                    isCreatAble={true}
                                    isClearable={senderValue?.id || senderValue?.name}
                                    // optionsTemplate={PartnerSelect}
                                    labelKey="name"
                                    valueKey="id"
                                    storeType="remote"
                                    onInputValueChanged={(name) => {
                                        if (!senderValue?.id) {
                                            this.props.setFieldValue("sender", null);
                                            this.props.setFieldValue("sender_name", name);
                                        }
                                    }}
                                    {...this.props.getFieldProps("sender")}
                                    value={senderValue}
                                    saveChanges={(field, value) => {
                                        if (!value?.id) {
                                            this.props.setFieldValue(field, null);
                                            this.props.setFieldValue("sender_name", value?.name || null);
                                        } else {
                                            this.props.setFieldValue(field, value);
                                            this.props.setFieldValue("sender_name", null);
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-sm-6">
                                <Select
                                    name="location"
                                    component={"PointOfSale"}
                                    objectValue={false}
                                    storeType="remote"
                                    label="Hova"
                                    value={this.props.values.location}
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                        <div className="row form-row">
                            <div className="col-sm-8">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="delivery_description"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Leírás"
                                />
                            </div>
                            <div className="col-sm-4">
                                <DateTimeInput
                                    {...this.props.getFieldProps("estimated_reception_date")}
                                    name="estimated_reception_date"
                                    value={this.props.values.estimated_reception_date}
                                    label="Beérkezés becsült időpontja"
                                    showTime={true}
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div className="row form-row">
                            <div className="col-sm-2">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name={this.props.componentConfig.idfield}
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Kód"
                                />
                            </div>
                            <div className="col-sm-4">
                                <Select
                                    name="locations"
                                    component={"PointOfSale"}
                                    objectValue={false}
                                    storeType="remote"
                                    label="Átvétel helye"
                                    isMulti={true}
                                    filter={{field: "location", operator: "not isnull"}}
                                    value={this.props.values.location}
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                            <div className="col-sm-4">
                                <Select
                                    name="dispatcher"
                                    component={"user"}
                                    objectValue={false}
                                    storeType="remote"
                                    label="Átvevő"
                                    filter={[
                                        {
                                            field: "privileges.name",
                                            value: "admin"
                                        }
                                    ]}
                                    value={this.props.values.dispatcher}
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                            <div className="col-sm-2">
                                <Select
                                    name="state"
                                    optionname="delivery_state"
                                    objectValue={false}
                                    storeType="local"
                                    label="Státusz"
                                    disabled={true}
                                    value={this.props.values.state}
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                        <div className="row form-row">
                            <div className="col-md-2">
                                <Select
                                    label="Kitől / honnan"
                                    name="sender"
                                    component="user"
                                    objectValue={true}
                                    isCreatAble={true}
                                    isClearable={senderValue?.id || senderValue?.name}
                                    // optionsTemplate={PartnerSelect}
                                    labelKey="name"
                                    valueKey="id"
                                    storeType="remote"
                                    onInputValueChanged={(name) => {
                                        if (!senderValue?.id) {
                                            this.props.setFieldValue("sender", null);
                                            this.props.setFieldValue("sender_name", name);
                                        }
                                    }}
                                    {...this.props.getFieldProps("sender")}
                                    value={senderValue}
                                    saveChanges={(field, value) => {
                                        if (!value?.id) {
                                            this.props.setFieldValue(field, null);
                                            this.props.setFieldValue("sender_name", value?.name || null);
                                        } else {
                                            this.props.setFieldValue(field, value);
                                            this.props.setFieldValue("sender_name", null);
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-sm-2">

                                <Select
                                    label="Kinek"
                                    name="recipient"
                                    component="user"
                                    objectValue={true}
                                    isCreatAble={true}
                                    isClearable={recipientValue?.id || recipientValue?.name}
                                    filter={[
                                        {
                                            field: "privileges.name",
                                            value: "admin"
                                        }
                                    ]}
                                    // optionsTemplate={PartnerSelect}
                                    labelKey="name"
                                    valueKey="id"
                                    storeType="remote"
                                    onInputValueChanged={(name) => {
                                        if (!recipientValue?.id) {
                                            this.props.setFieldValue("recipient", null);
                                            this.props.setFieldValue("recipient_name", name);
                                        }
                                    }}
                                    {...this.props.getFieldProps("recipient")}
                                    value={recipientValue}
                                    saveChanges={(field, value) => {
                                        if (!value?.id) {
                                            this.props.setFieldValue(field, null);
                                            this.props.setFieldValue("recipient_name", value?.name || null);
                                        } else {
                                            this.props.setFieldValue(field, value);
                                            this.props.setFieldValue("recipient_name", null);
                                        }
                                    }}
                                />

                                {/*<Select*/}
                                {/*    name="recipient"*/}
                                {/*    component={"user"}*/}
                                {/*    objectValue={false}*/}
                                {/*    storeType="remote"*/}
                                {/*    label="Kinek"*/}
                                {/*    filter={[*/}
                                {/*        {*/}
                                {/*            field: "privileges.name",*/}
                                {/*            value: "admin"*/}
                                {/*        }*/}
                                {/*    ]}*/}
                                {/*    value={this.props.values.recipient}*/}
                                {/*    saveChanges={this.props.setFieldValue}*/}
                                {/*/>*/}
                            </div>
                            <div className="col-sm-2">
                                <Select
                                    name="group"
                                    component={"Group"}
                                    objectValue={false}
                                    storeType="local"
                                    label="Kiknek"
                                    filter={[
                                        {
                                            field: "email",
                                            operator: "not isnull"
                                        }
                                    ]}
                                    value={this.props.values.group}
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="delivery_description"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Leírás"
                                />
                            </div>
                        </div>
                        <div className="row form-row">
                            {this.props.values.state>0 &&
                                <>
                                    <div className="col-sm-3">
                                        <DateTimeInput
                                            {...this.props.getFieldProps("reception_date")}
                                            name="reception_date"
                                            value={this.props.values.reception_date}
                                            label="Beérkezés időpontja"
                                            showTime={true}
                                            saveChanges={this.props.setFieldValue}
                                        />
                                    </div>
                                    <div className="col-sm-9">
                                        <ComponentField
                                            getFieldProps={this.props.getFieldProps}
                                            componentConfig={this.props.componentConfig}
                                            name="placement"
                                            values={this.props.values}
                                            setFieldValue={this.props.setFieldValue}
                                            label="Hova tettük"
                                        />
                                    </div>
                                </>
                            }
                        </div>
                        <div className="row form-row">
                            {this.props.values.state > 1 &&
                                <div className="col-sm-3">
                                    <DateTimeInput
                                        {...this.props.getFieldProps("delivery_date")}
                                        name="delivery_date"
                                        value={this.props.values.delivery_date}
                                        label="Átadás időpontja"
                                        showTime={true}
                                        saveChanges={this.props.setFieldValue}
                                    />
                                </div>
                            }
                        </div>
                    </>
                }
            </form>
        );
    }
}

export default createForm(DeliveryForm);
